import { render, staticRenderFns } from "./FileBlock.vue?vue&type=template&id=c400f9ac&scoped=true"
import script from "./FileBlock.vue?vue&type=script&lang=js"
export * from "./FileBlock.vue?vue&type=script&lang=js"
import style0 from "./FileBlock.vue?vue&type=style&index=0&id=c400f9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c400f9ac",
  null
  
)

export default component.exports